import { IRoleParticipantsInformation } from "@multiweb/reactCore/workflow/types";
import { RecordType, RootNodeTypedObject, TypedObject } from "@multiweb/types/react";

/**
 * Převede klíče objektů na malá písmena a hodnotu převede do struktury { value: hodnota },
 * pokud je hodnota pole tak projde potomky a zavola na ně sama sebe
 *
 * @param rawParticipantsData
 */
export const mapKeyToLowerArray = <T extends TypedObject<any>>(rawParticipantsData: readonly T[]): RecordType[] => {
    return rawParticipantsData
        .map(row =>
            Object.fromEntries(
                Object.keys(row)
                    .map(key =>
                        [
                            key.toLowerCase(),
                            ({
                                value:
                                    Array.isArray(row[key])
                                        ? mapKeyToLowerArray(row[key])
                                        : row[key],
                            }),
                        ],
                    ),
            ),
        );
};

/**
 * Převede pole uživatelů do struktury: nadřazená role a její potomci a potomci, kteří jsou ve více rolích.
 * @param participantsData data k vytvoření uzlových záznamů.
 */
export const createRootNodesMaps = (participantsData: IRoleParticipantsInformation[]) => {
    const owners: RootNodeTypedObject = {};
    const childOwnerInvertedMap: { [key: string]: string[] } = {};

    for (const data of participantsData) {
        const ownerId: string = data.id.value.toString();
        if (data?.roleusers && data?.roleusers.value.length > 0) {
            owners[ownerId] = { children: [], inRootNodes: [] }; // Pokud role má uživatele, jedná se o uzlový záznam.
            for (const user of data.roleusers.value) {
                const userId = user.id.value.toString();
                owners[ownerId].children.push(userId);

                // Pomocná struktura pro rychlé zjištění zda uživatel není i v jiné roli.
                if (!childOwnerInvertedMap[userId]) {
                    childOwnerInvertedMap[userId] = [ownerId];
                } else {
                    childOwnerInvertedMap[userId].push(ownerId);
                }
            }
        }
    }

    const childrenInOtherRootNodes: RootNodeTypedObject = {};

    for (const child in childOwnerInvertedMap) {
        if (childOwnerInvertedMap[child].length > 1) {
            childrenInOtherRootNodes[child] = { children: [], inRootNodes: childOwnerInvertedMap[child] }; // Pokud je uživatel ve více rolích, tak se opět jedná o uzlový záznam.
        }
    }

    return { ...owners, ...childrenInOtherRootNodes };
};
